export default {
  sm: `
  과거와 현재의
  기록을 넘어
  미래를 위한 지혜로
  `,
  md: `
  과거와 현재의
  기록을 넘어 미래를
  위한 지혜로
  `,
  lg: `
  과거와 현재의 기록을 
  넘어 미래를 위한 지혜로  
  `,
  xxl: `
  과거와 현재의 기록을 넘어
  미래를 위한 지혜로
  `
};
